import {isMatchMedia, isMatchMediaGrid} from '%helpers%/utils';

export function shouldEnableSwiper(swiperEl) {
  if (!swiperEl) return false;

  const expandClass = Array.from(swiperEl.classList).find(cls => cls.startsWith('swiper-expand-'));

  if (!expandClass) return true;

  const bpKey = expandClass.replace('swiper-expand-', '').toLowerCase();

  return !isMatchMediaGrid(bpKey);
}

export function applyCustomSwiperWidth(widget, swiperEl) {
  if (widget.closest('.page-header')) return;
  const containerEl = widget.querySelector('.container') || widget.closest('.container');
  const wrapper = widget.querySelector('.slider-container');
  if (!containerEl || !wrapper) return;

  const setWidth = () => {
    if (shouldEnableSwiper(swiperEl) && !isMatchMedia('container-width')) {
      const viewportWidth = document.documentElement.clientWidth;
      const containerRect = containerEl.getBoundingClientRect();
      const containerStyle = getComputedStyle(containerEl);
      const paddingLeft = parseFloat(containerStyle.paddingLeft) || 0;
      const leftOffset = containerRect.left;

      let width = viewportWidth - leftOffset - paddingLeft;

      wrapper.style.width = `${width}px`;
    } else {
      widget.classList.remove('has-custom-width');
      wrapper.style.width = '';
    }
  };

  const resizeHandler = () => requestAnimationFrame(setWidth);
  window.addEventListener('resize', resizeHandler, {passive: true});

  const modal = widget.closest('.modal');
  if (modal) {
    modal.addEventListener('shown.bs.modal', setWidth);
  }

  setWidth();

  return () => {
    window.removeEventListener('resize', resizeHandler);
    if (modal) modal.removeEventListener('shown.bs.modal', setWidth);
    wrapper.classList.remove('has-custom-width');
    wrapper.style.width = '';
  };
}

export function getAttr(widget, name, bp = '', fallback) {
  const key = name + (bp ? bp[0].toUpperCase() + bp.slice(1) : '');
  const value = widget.dataset[key];
  if (value === undefined) return fallback;
  return isNaN(value) ? value : Number(value);
}

export function getBreakpoints(widget) {
  const bps = [
    {width: 0, key: '', fallbackSlides: 'auto', fallbackSpace: 16},
    {width: 768, key: 'md'},
    {width: 1024, key: 'lg'},
    {width: 1200, key: 'xl'},
  ];

  let lastSlidesPerView = 'auto';
  let lastSpaceBetween = 16;

  return bps.reduce((acc, {width, key, fallbackSlides, fallbackSpace}) => {
    const slidesPerView = getAttr(widget, 'swiperSlidesPerView', key, fallbackSlides ?? lastSlidesPerView);
    const spaceBetween = getAttr(widget, 'swiperSpaceBetween', key, fallbackSpace ?? lastSpaceBetween);

    acc[width] = {
      slidesPerView,
      spaceBetween,
    };

    lastSlidesPerView = slidesPerView;
    lastSpaceBetween = spaceBetween;

    return acc;
  }, {});
}
